// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// sonarsas.colombia@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyAj7bYFhnftcdptkJhTbHqA3z0jBWWbEWo",
    authDomain: "sonarsas.firebaseapp.com",
    projectId: "sonarsas",
    storageBucket: "sonarsas.firebasestorage.app",
    messagingSenderId: "171518396776",
    appId: "1:171518396776:web:c44c24ab65d97e76102edd",
    measurementId: "G-LE41D3L14J"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)